
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonPage,
  IonRouterOutlet,
  IonLabel

} from "@ionic/vue";

import { defineComponent, onMounted, onBeforeUnmount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { mapState, useStore } from 'vuex';
import _t from '@/components/TranslateComponent.vue';
import { bool } from "aws-sdk/clients/signer";


const __default__ = defineComponent({
  name: 'App',
  components: {
    IonTabBar,
    IonTabButton,
    IonTabs,
    IonPage,
    IonRouterOutlet,
    IonLabel,
  },
  mixins: [_t],
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const handler = (e: any) => {
      store.commit('updateDeferredPrompt', e);
    };

    onMounted(() => {
      window.addEventListener('beforeinstallprompt', handler);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('beforeinstallprompt', handler);
    });

    return { route, router };
  },


  computed: {
    ...mapState({
      token: (state: any) => state.token,
      lang: (state: any) => state.lang,
      level: (state: any) => state.level,
      limited: (state: any) => state.limited,
      myrPartner: (state: any) => state.myrPartner,
    }),
    menumargin() {
      const path = this.route && this.route.path ? this.route.path : '';
      return this.token && !path.includes('changepassword') ? '270px' : '0px';
    }
  },
  methods: {
    goMyrRoot() {
      // Force un retour au root de l'onglet MyRoutine+
      if (this.route.path !== '/myr') {
        this.router.push('/myr');
      } else {
        // Si déjà sur /myr, on remplace pour éviter d'empiler
        this.router.replace('/myr');
      }
    }
  }
},
);




import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "1cfa8d3a": (_ctx.menumargin)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__